import axios from 'axios';

export default async function getGroups({
  accessToken,
  page = 0,
  pageSize = 100,
  query = '',
  isGetgroups = false,
}) {
  try {
    if (isGetgroups) isGetgroups(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_GROUPS_API_URL}?page=${page}&pageSize=${pageSize}&query=${query}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    return null;
  } finally {
    if (isGetgroups) isGetgroups(false);
  }
}
